import dayjs from 'dayjs';
import useAxios from 'hooks/useAxios';

export const getMetrics = async (limit = 20, page = 1, filters = '') => {
  const api = useAxios();
  let dateFrom = filters.startDate || '';
  let dateTo = filters.endDate || '';
  let params = {
    limit: limit,
    page: page,
    startDate: dateFrom,
    endDate: dateTo
  };

  if (filters?.search) {
    params.search = filters.search;
  }

  if (filters?.roundHash) {
    params['filter.jetpackRound.hash'] = filters.roundHash;
  }

  if (dateFrom === '') {
    dateFrom = dayjs().date(1).month(1).year(2000);
    dateFrom = dateFrom.toJSON();
    params.startDate = dateFrom;
  } else {
    dateFrom = new Date(dateFrom).toISOString();
    params.startDate = dateFrom;
  }

  if (dateTo === '') {
    dateTo = dayjs();
    dateTo = dateTo.toJSON();
    params.endDate = dateTo;
  } else {
    dateTo = new Date(dateTo).toISOString();
    params.endDate = dateTo;
  }

  // Handle entity filters
  if (filters.clientId) params.clientId = filters.clientId;
  if (filters.operatorId) params.operatorId = filters.operatorId;
  if (filters.brandId) params.brandId = filters.brandId;
  if (filters.gameType) params.gameType = filters.gameType;
  if (filters.country) params.country = filters.country;
  try {
    const unformattedData = await api.get('/metric', {
      params
    });
    return {
      data: unformattedData.data.data.map((x) => {
        return {
          ...x,
          playerUsername: x.session.player.username,
          game: x.session.game.name,
          betRange: x.session.betLimit,
          currency: x.session.player.currency,
          client: x.session.player.client.name,
          sessionCountry: x.session?.country,
          playerNickname: x.session?.player?.nickname,
          createdAt: formatDateToLocal(x.createdAt)
        };
      }),
      meta: unformattedData.data.meta
    };
  } catch (err) {
    console.error(err);
    return {
      data: [],
      meta: {
        totalItems: 0,
        itemCount: 0,
        itemsPerPage: 0,
        totalPages: 0,
        currentPage: 0
      }
    };
  }
};

export const formatDateToLocal = (dateString) => {
  // console.log(dateString);
  const date = new Date(dateString);
  return new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  }).format(date);
};

export const convertUTCTimeToLocal = (timeStr) => {
  const today = new Date();
  const [h, m, s] = timeStr.split(':').map(Number);
  const utcDate = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate(), h, m, s));

  return new Intl.DateTimeFormat(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  }).format(utcDate);
};

export const localTimeToUTC = (timeStr) => {
  const parts = timeStr.split(':').map(Number);
  const [hours, minutes, seconds = 0] = parts;

  const now = new Date();
  const localDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, seconds);

  const utcHours = localDate.getUTCHours().toString().padStart(2, '0');
  const utcMinutes = localDate.getUTCMinutes().toString().padStart(2, '0');
  const utcSeconds = localDate.getUTCSeconds().toString().padStart(2, '0');

  return `${utcHours}:${utcMinutes}:${utcSeconds}`;
};

// filter endpoints

export const getMetricClients = async () => {
  const api = useAxios();
  try {
    const res = await api.get('/metric/clients');
    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
};

export const getMetricGames = async () => {
  const api = useAxios();
  try {
    const res = await api.get('/metric/game-types');
    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
};

export const getMetricCountries = async () => {
  const api = useAxios();
  try {
    const res = await api.get('/metric/countries');
    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
};

export const exportMetrics = async (params) => {
  const api = useAxios();
  const hasStart = !!params?.startDate;
  const hasEnd = !!params?.endDate;

  const startDateISO = hasStart
    ? dayjs(params.startDate).toISOString()
    : dayjs().year(2000).month(0).date(1).startOf('day').toISOString();

  const endDateISO = hasEnd ? dayjs(params.endDate).toISOString() : dayjs().endOf('day').toISOString();

  const query = {
    ...params,
    startDate: startDateISO,
    endDate: endDateISO
  };

  // const req = {
  //   startDate,
  //   endDate,
  //   country,
  //   clientId,
  //   gameType
  //   // metricType: 'bet',
  //   // currency: 'USD',
  //   // rolledBack: true,
  //   // bossBet: true
  // };

  try {
    const res = await api.get('/metric/export/csv', { params: query, responseType: 'blob' });
    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
};
